import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { round } from 'lodash';
import WeightSelect from './weight-select';
import './index.css';

const unitValues = {
  kg: {
    min: 30,
    max: 205,
    maxPercent: -87.5,
    tickDistance: .5,
    conversion: 1,
    sliderWidth: 2000,
    tickDistances: [{
      distance: 10,
      className: 'large-tick',
      displayValue: true
    },
    {
      distance: 5,
      className: 'medium-tick',
      displayValue: false
    }]
  },
  lbs: {
    min: 70,
    max: 450,
    maxPercent: -95,
    tickDistance: .25,
    conversion: 2.20462,
    sliderWidth: 4000,
    tickDistances: [{
      distance: 10,
      className: 'large-tick',
      displayValue: true
    },
    {
      distance: 5,
      className: 'medium-tick',
      displayValue: false
    }]
  }
};

class UserProfileWeight extends Component {
  static propTypes = {
    initialValue: PropTypes.number,
    initialUnit: PropTypes.string,
    onChange: PropTypes.func.isRequired
  };

  static defaultProps = {
    initialValue: 68,
    initialUnit: 'standard',
  };

  constructor(props) {
    super(props);

    this.state = {
      metricWeight: props.initialValue,
      unitSystem: props.initialUnit,
    };

    props.onChange(this.state.metricWeight, this.state.unitSystem);
  }

  setWeight = (event, payload) => {
    const weight = this.state.unitSystem === 'metric' ? payload : round(payload / (unitValues.lbs.conversion / unitValues.kg.conversion), 1);
    this.setState({ metricWeight: weight });
    this.props.onChange(weight, this.state.unitSystem);
  }

  resetWeight = () => {
    this.setState({ metricWeight: null });
  }

  setUnitSystem = (event, value, payload) => {
    this.setState({ unitSystem: payload });
    this.props.onChange(this.state.metricWeight, payload);
  }

  getDisplayWeight() {
    if (!this.state.metricWeight) {
      return '';
    } else if (this.state.unitSystem === 'metric') {
      return Math.round(this.state.metricWeight);
    } else {
      return Math.round(
        this.state.metricWeight / (unitValues.kg.conversion / unitValues.lbs.conversion)
      );
    }
  }

  render() {
    return (
      <WeightSelect
        unitSystem={ this.state.unitSystem }
        displayWeight={ this.getDisplayWeight() }
        setWeight={ this.setWeight }
        resetWeight={ this.resetWeight }
        setUnitSystem={ this.setUnitSystem }
      />
    );
  }
}

export default UserProfileWeight;
